import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  arrow: {
    width: 20,
    height: 20,
    padding: "2px",
    marginTop: "2px",
    cursor: "pointer",
    color: theme.palette.grey[600],
  },
  arrowSmall: {
    width: 20,
    height: 20,
    position: "relative",
  },
  arrowDisabled: {
    cursor: "default",
    color: theme.palette.grey[400],
  },
  textfield: {
    "& .MuiAutocomplete-clearIndicator": {
      padding: "6px",
      color: theme.palette.grey[600],
    },
    "& .MuiAutocomplete-clearIndicator svg": {
      width: 16,
      height: 16,
    },
    "& .MuiAutocomplete-endAdornment": {
      right: "0 !important",
      paddingRight: 12,
    },
    "& .MuiInputBase-root": {
      paddingRight: 36,
      paddingTop: 0,
      paddingBottom: 0,
    },
    "& fieldset": {
      boxShadow: "0 1px 1px rgba(0, 0, 0, 0.1) !important",
    },
  },
  textfieldSmall: {
    "& .MuiAutocomplete-endAdornment": {
      paddingRight: 8,
    },
  },
  textfieldDisabled: {
    "& fieldset": {
      boxShadow: "none !important",
    },
  },
  textfieldInfo: {
    "& .MuiAutocomplete-endAdornment": {
      paddingRight: 40,
    },
  },
  textfieldMultiple: {
    "& .MuiInputBase-root": {
      flexWrap: "wrap",
      paddingTop: 3,
      paddingLeft: 4,
      paddingBottom: 3,
      paddingRight: 68,
      minHeight: 40,
      height: "auto",
    },
    "& .MuiAutocomplete-input": {
      width: 0,
      margin: 0,
      padding: "0 0 0 4px",
      height: 20,
    },
    "& .MuiAutocomplete-tag": {
      fontSize: 14,
    },
    "&$textfieldSmall .MuiInputBase-root": {
      minHeight: 36,
    },
  },
}));

export const useChipStyles = makeStyles((theme) => ({
  root: {
    height: 28,
    margin: "2px 2px",
    borderRadius: 4,
    background: theme.palette.grey[200],
    maxWidth: "calc(100% - 36px)",
    "& .MuiChip-deleteIcon": {
      width: 16,
      height: 16,
    },
  },
  sizeSmall: {
    fontSize: 12,
  },
}));
